import { useWorkOrderMoves } from '../hooks/use-work-order-moves';
import { useWorkOrderPermissions } from '../hooks/use-work-order-permissions';
import type { WorkOrderApprovalReadiness, WorkOrderView } from '../work-orders.api';
import { WorkOrderActions } from './WorkOrderActions';

interface WorkOrderMovesBarProps {
  order: WorkOrderView;
  readiness: WorkOrderApprovalReadiness | null;
  reload: () => Promise<void>;
}

/** The order's moves under its header. The bar owns the move state so a refusal shows beside the buttons that caused it. */
export function WorkOrderMovesBar({ order, readiness, reload }: WorkOrderMovesBarProps) {
  const permissions = useWorkOrderPermissions();
  const moves = useWorkOrderMoves(order, reload);

  return (
    <div className="mb-4">
      <WorkOrderActions order={order} permissions={permissions} readiness={readiness} moves={moves} />
    </div>
  );
}
